import React, { useCallback, useEffect } from "react";
import { FaRegSun } from "react-icons/fa";
import $ from "jquery";

let currentWallet;
let currentFees;
let currentVat;
let currentbuyingList;

export default function Settings({
  buyingList,
  setBuyingLists,
  wallet,
  setWallet,
  handleWallet,
  fees,
  setFees,
  vat,
  setVat,
}) {
  useEffect(() => {
    handleWallet();
  }, [wallet, fees, vat]);

  const addCredit = useCallback(
    (e) => {
      setWallet(e.target.value);
    },
    [setWallet]
  );

  const changeFees = useCallback(
    (e) => {
      setFees(e.target.value);
    },
    [setFees]
  );

  const changeVat = useCallback(
    (e) => {
      setVat(e.target.value);
    },
    [setVat]
  );

  const getSettings = () => {
    currentWallet = +document.getElementById("wallet").value;
    currentFees = +document.getElementById("fees").value;
    currentVat = +document.getElementById("vat").value;
    currentbuyingList = buyingList;
  };

  $("#settingsModal").on("show.bs.modal", function () {
    getSettings();
  });

  const restSettings = () => {
    setWallet(currentWallet);
    setFees(currentFees);
    setVat(currentVat);
    setBuyingLists(currentbuyingList);
  };

  return (
    <div>
      <span data-toggle="modal" data-target="#settingsModal">
        <button
          className="btn btn-sm btn-outline-light"
          data-toggle="tooltip"
          data-placement="bottom"
          title="الاعدادات"
          onClick={() => $("button").tooltip("hide")}
        >
          <FaRegSun size="1.2em" />
        </button>
      </span>
      <div
        className="modal fade"
        id="settingsModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-dark" id="exampleModalLabel">
                لوحة التحكم
              </h5>
              <button
                type="button"
                className="close ml-0"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="form-row">
                  <div className="form-group col-md-12 text-right">
                    <label htmlFor="inputEmail4" className="text-dark">
                      رصيد الحساب
                    </label>
                    <input
                      value={wallet}
                      onChange={addCredit}
                      type="number"
                      className="form-control"
                      id="wallet"
                      placeholder="الرصيد الحالي"
                    ></input>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-md-12 text-right">
                    <label htmlFor="inputEmail4" className="text-dark">
                      عمولة التداول %
                    </label>
                    <input
                      value={fees}
                      onChange={changeFees}
                      type="number"
                      className="form-control"
                      id="fees"
                    ></input>
                    <small className="form-text text-muted">
                      العمولة على عمليات الشراء والبيع
                    </small>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-md-12 text-right">
                    <label htmlFor="inputEmail4" className="text-dark">
                      ضريبة القيمة المضافة %
                    </label>
                    <input
                      value={vat}
                      onChange={changeVat}
                      type="number"
                      className="form-control"
                      id="vat"
                    ></input>
                    <small className="form-text text-muted">
                      الضريبة تحسب على عمولة التداول
                    </small>
                  </div>
                </div>
                <button
                  className="btn btn-danger btn-block"
                  onClick={(e) => {
                    e.preventDefault();
                    setWallet(100000);
                    setFees(0.155);
                    setVat(15);
                    setBuyingLists([]);
                  }}
                >
                  اعادة ضبط التطبيق
                </button>
                <small className="form-text text-danger">
                  سيتم حذف جميع البيانات والمدخلات ، للتراجع اضغط الغاء في
                  الاسفل
                </small>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                onClick={getSettings}
              >
                حفظ
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={restSettings}
              >
                الغاء
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
